<template>
    <div id="section" class="Section">  

        MOBILE !

        <!-- 
        <Map/>
        <Bottom v-if="$route.meta.name != 'buddy' || $route.meta.name != 'experience'"/>
        <Splash v-if="$route.meta.name == 'experience'"/>
        <Buddy v-if="$route.meta.name == 'buddy'"/>
        <About v-if="$route.meta.name == 'about'"/> 
        -->

    </div>
</template>

<script> 

import Mixin from '@/mixins/Smooth.js'

// import Map from '@/components/Map.vue'
// import Bottom from '@/components/Bottom.vue'
// import Splash from '@/components/Splash.vue'
// import Buddy from '@/components/Buddy.vue'
// import About from '@/components/About.vue'

export default {
    name: 'Section',
    mixins: [Mixin],
    // components: { Map, Bottom, Splash, Buddy, About },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight
    }),
    mounted() {
    },
    methods: {  
        // onClick: async function() {
        //     if(this.open)
        //         await this.$refs.complements.leave()
        //     this.open = !this.open
        // },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Section 
    color black
    display flex
    position fixed
    top 0
    left 0
    width 100vw
    height 100%
    background-color red
    color white
       
</style>


